/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { Typography2 } from '@coursera/cds-core';
import { MembersIcon } from '@coursera/cds-icons';

const styles = {
  container: css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: var(--cds-spacing-400);
    border-radius: 0 0 var(--cds-border-radius-100) var(--cds-border-radius-100);
    border: 1px solid var(--cds-color-neutral-stroke-primary-weak);
    border-top: none;
  `,
  icon: css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    background-color: var(--cds-color-emphasis-neutral-background-xweak);
    border-radius: var(--cds-border-radius-max);
  `,
  label: css`
    margin-top: var(--cds-spacing-200);
  `,
};

export const CDSTableEmptyState = ({ label }: { label: string }) => {
  return (
    <div css={styles.container}>
      <div css={styles.icon}>
        <MembersIcon />
      </div>
      <Typography2 component="p" color="supportText" css={styles.label}>
        {label}
      </Typography2>
    </div>
  );
};
